import * as yup from 'yup'

export const schemaUser = (isSupplier) => {
  return yup.object().shape({
    ...(!isSupplier && { profileId: yup.string().required() }),
    fileToImport: yup.string(),
  })
}

export default schemaUser
